<template lang="pug">
#selecionar-territorio
    el-input.mb-3(
        placeholder='Procure por um território ou pessoa vinculada',
        prefix-icon='el-icon-search',
        v-model='filtroSelecionarTerritorio',
        @change='findAllTerritoriosSimplificado'
    )
    
    .selecionar-todos.mb-3(v-if='this.territoriosNaoSelecionados.length > 1', style="flex-direction: row; flex-wrap: wrap")
        el-checkbox.ml-0(
            border,
            v-for='(checkbox, indice) in checkboxesTodos'
            v-model='checkbox.check'
            @change='selecionarCheckboxTodos(indice)',
            :key='checkbox.id'
            style='flex: 1 0 21%; margin-right: 2px !important; margin-top: 2px !important'
        )
            p.m-0
                b {{checkbox.texto}}

    .conteudo
        .nao-selecionados(v-if='paginatedNaoSelecionados')
            el-checkbox.ml-0.lista-mb(
                v-for='(territorio, index) in paginatedNaoSelecionados',
                v-model='territorio.check',
                border,
                @change='selecionarTerritorio(index)',
                :key='territorio.id',
                :checked='territorio.selecionado'
            )
                p.m-0
                    b {{ territorio.nome }}
                    br
                    em {{ territorio.totalRepresentantes }} {{ territorio.totalRepresentantes <= 1 ? 'pessoa' : 'pessoas' }}

    .selecionar-territorio__paginacao.mt-3
        el-pagination(
            background,
            :page-size='itemsPerPage',
            :pager-count='pagerCount',
            :current-page.sync='currentPage',
            layout='prev, pager, next',
            :total='todosTerritorios.length',
            @current-change='handlePageChange'
        )
    .botao.marginButton(slot='footer')
        el-button(
            type='primary',
            size='small',
            @click='enviarIdsTerritoriosSelecionados'
        )
            | Adicionar
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import formatters from '@/utils/formatters';

import { ordem } from '@/utils/ordenacao';

const LIMITE_ENVIO_TERRITORIOS = 1000;

export default {
    name: 'SelecionarTerritorio',
    props: {
        selecionados: {
            type: [],
            default() {
                return [];
            }
        }
    },

    emits: ['getIdsTerritoriosSelecionados'],

    data() {
        return {
            filtroSelecionarTerritorio: '',
            territoriosSelecionados: [],
            territoriosNaoSelecionados: [],
            selecionarTodosRangeInicial: false,
            selecionarTodosRangeIntermediario: false,
            selecionarTodosRangeFinal: false,
            currentPage: 1,
            itemsPerPage: 10,
            pagerCount: 5,
            checkboxesTodos: []
        };
    },

    mounted() {
        this.ajustarJaSelecionados();
    },
    watch: {
        selecionados: function () {
            this.ajustarJaSelecionados();
        },
        territoriosNaoSelecionados: function () {
            this.checkboxesTodos = [];
            this.criarCheckboxesTodos();
        }
    },
    computed: {
        paginatedNaoSelecionados() {
            const copy = [...this.territoriosNaoSelecionados];
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return copy.slice(startIndex, endIndex);
        },
        todosTerritorios() {
            return [...this.territoriosNaoSelecionados];
        }
    },
    methods: {
        async findAllTerritoriosSimplificado() {
            const filtroAtual = this.getFiltroSelecionarTerritorio();

            try {
                const idsTerritoriosSelecionadosAntesDaPesquisa =
                    this.territoriosSelecionados.map(
                        territorio => territorio.id
                    );

                // await this.findTerritorioSimplificadoPorCar();

                const { data } = await TerritorioService.findAllSimplificado(
                    filtroAtual
                );
                this.territoriosNaoSelecionados = data;
                this.territorios = data;

                this.territoriosNaoSelecionados.forEach(territorio => {
                    territorio.check =
                        idsTerritoriosSelecionadosAntesDaPesquisa.includes(
                            territorio.id
                        );
                });
                this.checkBoxSelecionarTodos();
            } catch (error) {
                this.$notify.error({
                    message: 'Ocorreu um erro ao buscar os territórios'
                });
            }
        },

        selecionarTerritorio(index) {
            var territorio = this.paginatedNaoSelecionados[index];

            if (
                territorio.check &&
                !this.territoriosSelecionados.some(
                    item => item.id === territorio.id
                )
            ) {
                if (this.isMarcacaoInvalida(index)) {
                    this.$set(territorio, 'check', false);
                } else {
                    this.territoriosSelecionados.push(territorio);
                }
            } else if (!territorio.check) {
                const indexSelecionados =
                    this.territoriosSelecionados.findIndex(
                        item => item.id === territorio.id
                    );
                if (indexSelecionados !== -1) {
                    this.territoriosSelecionados.splice(indexSelecionados, 1);
                }

                var checkboxTodos = this.buscarCheckboxTodos(index);

                if (checkboxTodos !== null) {
                    this.$set(checkboxTodos, 'check', false);
                }

            }
            this.checkBoxSelecionarTodos();
            this.$forceUpdate();
        },

        isMarcacaoInvalida(index) {
            this.checkboxesTodos.forEach(checkbox => {
                if (checkbox.check) {
                    if (index > checkbox.min - 1 || index < checkbox.max) {
                        return true;
                    }
                }
            });
            return false;
        },

        buscarCheckboxTodos(indexTerritorio) {
            for (let index = 0; index < this.checkboxesTodos.length; index++) {
                var element = this.checkboxesTodos[index];

                if (indexTerritorio >= element.min - 1 && indexTerritorio < element.max) {
                    return element;
                }
                
            }
            return null;
        },

        enviarIdsTerritoriosSelecionados() {
            if (
                this.territoriosSelecionados.length > LIMITE_ENVIO_TERRITORIOS
            ) {
                this.$notify.error(
                    'É possível enviar apenas 1000 territórios de uma vez'
                );
                return;
            }

            const idsTerritoriosSelecionados = [];
            this.territoriosSelecionados.forEach(({ id }) => {
                idsTerritoriosSelecionados.push(id);
            });

            this.$emit(
                'getIdsTerritoriosSelecionados',
                idsTerritoriosSelecionados
            );
        },

        ajustarJaSelecionados() {
            this.territoriosSelecionados = [];
            this.selecionados.forEach(({ id, nome, representantes }) => {
                this.territoriosSelecionados.push({
                    id,
                    nome,
                    totalRepresentantes: representantes.length
                });
            });
            this.findAllTerritoriosSimplificado();
        },

        selecionarCheckboxTodos(indexSelectTodos) {
            const checkbox = this.checkboxesTodos[indexSelectTodos];
            this.resetarTerritorios();
            for (let index = checkbox.min - 1; index < checkbox.max; index++) {
                var checkTerritorio = this.territoriosNaoSelecionados[index];

                if (checkbox.check) {
                    this.$set(checkTerritorio, 'check', true);
                    this.territoriosSelecionados.push(checkTerritorio);

                    this.checkboxesTodos.forEach(item => {

                        if (item.id !== checkbox.id) {
                            this.$set(item, 'check', false);
                        }

                    });

                } else {
                    this.$set(checkTerritorio, 'check', false);
                }
                
            }
        },

        desSelecionarTodosTerritorios() {
            this.territoriosSelecionados = [];
            this.findAllTerritoriosSimplificado();
        },

        resetarTerritorios() {
            this.territoriosSelecionados = [];
            this.territoriosNaoSelecionados.forEach(item => {
                if (item.check) {
                    this.$set(item, 'check', false);
                }
            });
        },

        handlePageChange(newPage) {
            this.currentPage = newPage;
        },

        getFiltroSelecionarTerritorio() {
            if (this.filtroSelecionarTerritorio) {
                const cpfCnpj = formatters.cpfCnpjFormatToNumeral(
                    this.filtroSelecionarTerritorio
                );

                return cpfCnpj === ''
                    ? this.filtroSelecionarTerritorio
                    : cpfCnpj;
            }
            return '';
        },

        organizar() {
            const filtro = a => {
                let encontrado = false;
                this.territoriosSelecionados.forEach(({ id }) => {
                    if (a.id === id) {
                        encontrado = true;
                    }
                });
                return !encontrado;
            };

            this.territoriosSelecionados.sort((a, b) => ordem(a, b));
            this.territoriosNaoSelecionados.sort((a, b) => ordem(a, b));

            this.territoriosNaoSelecionados =
                this.territoriosNaoSelecionados.filter(territorio =>
                    filtro(territorio)
                );
        },

        checkBoxSelecionarTodos() {
            if (this.territoriosNaoSelecionados.length) {
                if (this.territoriosNaoSelecionados.every(item => item.check)) {
                    this.selecionarTodos = true;
                } else {
                    this.selecionarTodos = false;
                }
            }
        },

        criarCheckboxesTodos() {
            if (this.territoriosNaoSelecionados.length) {
                const qtdCheckboxesTodos = Math.ceil(this.territoriosNaoSelecionados.length / 1000);
                for (let index = 0; index < qtdCheckboxesTodos; index++) {
                    var element = null;

                    if (index === 0) {
                        if (this.territoriosNaoSelecionados.length > 1000) {
                            element = {id: index, texto: 'Selecionar do 1° ao ' + (index + 1) + '000°', checked: false, min: 1, max: 1000};
                        } else {
                            element = {id: index, texto: 'Selecionar do 1° ao ' + this.territoriosNaoSelecionados.length + '°', checked: false, min: 1, max: this.territoriosNaoSelecionados.length};
                        }
                    } else if (index === qtdCheckboxesTodos - 1) {
                        element = {id: index, texto: 'Selecionar do ' + index + '001° ao ' + this.territoriosNaoSelecionados.length + '°', checked: false, min: (index * 1000) + 1, max: this.territoriosNaoSelecionados.length};
                    } else {
                        element = {id: index, texto: 'Selecionar do ' + index + '001° ao ' + (index + 1) + '000°', checked: false, min: (index * 1000) + 1, max: (index + 1) * 1000};
                    }
                    this.checkboxesTodos.push(element);
                }
            }
        },

        async findTerritorioSimplificadoPorCar() {
            try {
                if (this.filtroSelecionarTerritorio) {
                    const { data } =
                        await TerritorioService.findSimplificadoPorCar(
                            this.filtroSelecionarTerritorio
                        );
                    data.forEach(territorio => {
                        if (
                            this.territoriosNaoSelecionados.some(
                                item => item.id === territorio.id
                            )
                        ) {
                        } else {
                            this.territoriosNaoSelecionados.push({
                                ...territorio
                            });
                        }
                    });
                }
            } catch {
                this.$notify.error({
                    message: 'Ocorreu um erro ao buscar os terrritórios'
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#selecionar-territorio {
    .conteudo {
        height: 50vh;
        overflow-y: auto;
        .lista-mb {
            margin-bottom: 5px !important;
        }
    }

    .selecionados,
    .nao-selecionados,
    .selecionar-todos {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }
    .selecionar-territorio__paginacao {
        display: flex;
        justify-content: center;
    }
    .botao {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
